// @flow
import * as React from 'react'
import { formatNumber } from '@/lib/FormatNumber/formatNumber'
import Link from 'next/link'
import Image from 'next/image'
interface MarqueeItemProps {
  crypto: CryptoType
}

export const MarqueeItem: React.FC<MarqueeItemProps> = ({ crypto }) => {
  return (
    <Link href={`/market/crypto/${crypto?.id}`}>
      <section className='flex gap-1 items-center justify-center h-full  py-[3px] px-[7px] rounded'>
        <>
          <p className='text-[11px] rounded-sm bg-slate-600/30 px-[5px] py-[2px] text-gray-200'>
            {crypto.market_cap_rank}
          </p>
        </>
        <>
          <div className='w-6 h-6 flex bg-white/10 rounded-full'>
            <Image
              src={crypto.image}
              alt={crypto.name}
              width={20}
              height={20}
              loading='lazy'
              className='w-5 h-5 m-auto object-cover rounded-full'
            />
          </div>
        </>
        <p
          className='text-sm font-bold uppercase
                              grow max-w-fit text-ellipsis line-clamp-1'
        >
          {crypto.symbol}
        </p>
        <p className='text-sm font-[400] max-w-fit line-clamp-1 text-ellipsis whitespace-nowrap grow '>
          {formatNumber(crypto.current_price)}
        </p>

        <div
          className={`rounded p-1 px-2 flex justify-center items-center gap-1 w-fit ${
            crypto.price_change_24h >= 0
              ? ' text-hero-green-330'
              : ' text-hero-pink-200'
          } transition-all duration-200`}
        >
          <>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='8'
              height='7'
              className={crypto.price_change_24h >= 0 ? 'rotate-180' : ''}
              viewBox='0 0 8 7'
              fill='none'
            >
              <path
                d='M7.66667 0.333373L0.333336 0.333374C0.272628 0.333399 0.21308 0.350002 0.161117 0.381391C0.109154 0.412781 0.0667505 0.457765 0.0384817 0.51149C0.010213 0.565214 -0.0028473 0.625638 0.000710363 0.686242C0.00426803 0.746845 0.0243085 0.805326 0.0586691 0.855374L3.72534 6.18871C3.75597 6.23326 3.79698 6.26969 3.84483 6.29486C3.89268 6.32002 3.94594 6.33318 4 6.33318C4.05407 6.33318 4.10733 6.32002 4.15518 6.29486C4.20303 6.26969 4.24404 6.23326 4.27467 6.18871L7.94134 0.855373C7.9757 0.805325 7.99574 0.746844 7.9993 0.68624C8.00285 0.625637 7.98979 0.565213 7.96152 0.511488C7.93326 0.457764 7.89085 0.412779 7.83889 0.38139C7.78693 0.35 7.72738 0.333397 7.66667 0.333373Z'
                className={
                  crypto.price_change_24h >= 0
                    ? 'fill-hero-green-330'
                    : 'fill-hero-pink-200'
                }
              />
            </svg>
          </>
          <p className='text-sm font-bold transition-all duration-200'>
            {formatNumber(crypto.price_change_24h)}
          </p>
          <p className='text-sm font-bold transition-all duration-200 '>
            ({formatNumber(crypto.price_change_percentage_24h)}%)
          </p>
        </div>
      </section>
    </Link>
  )
}
